import { IonIcon } from "@ionic/react";
import { flameOutline } from "ionicons/icons";
import { memo } from "react";

interface CaloriePlanCardProps {
  title: string;
  calories: number;
}

export const CaloriePlanCard = memo(function CaloriePlanCard({
  title,
  calories,
}: CaloriePlanCardProps) {
  return (
    <div className="bg-white rounded-2xl p-4 border border-gray-100 flex items-start gap-1">
      <div className="flex items-center gap-2 mb-2">
        <IonIcon icon={flameOutline} className="text-gray-600 w-4 h-4" />
      </div>
      <div className="flex flex-col gap-1">
        <span className="text-sm font-medium">{title}</span>
        <div className="flex items-baseline gap-1">
          <span className="font-medium text-black">{Math.round(calories)}</span>
          <span className="text-xs text-gray-500">kcal</span>
        </div>
      </div>
    </div>
  );
});
